import { useTranslation } from '../hooks';

export const Title = () => {
  const { t } = useTranslation();

  return <span data-test={t('catalogQuery.title')}>{t('catalogQuery.title')}</span>;
};
